import { enhancedTmsApiService } from '#api/enhancements/enhancedTmsApiService'
import type { BrakeCheckResponse } from '#api/tmsApiService'
import { type ResultUpdater, runCheck } from '#app/store/middlewares/configurationRequests/checks/runCheck'
import type { TruckConfiguration } from '#store/slices/configurationSlice'
import type { CheckResult, CheckTaskId } from '#types/ConfigurationCheck'
import type { AppListenerApi } from '../../configurationRequestMiddleware'

export const brakeRatioCheckId = 'checkBrakeRatio' as CheckTaskId

export function isBrakeRatioResult(result: CheckResult): result is CheckResult<BrakeCheckResponse> {
  return result.id === brakeRatioCheckId
}

export function runBrakeRatioCheck(api: AppListenerApi, configuration: TruckConfiguration, updater: ResultUpdater) {
  if (!configuration.uuid) {
    return
  }
  const promise = api.dispatch(
    enhancedTmsApiService.endpoints.getApiConfigurationByUuidCheckBrakeRatio.initiate(
      { uuid: configuration.uuid },
      {
        forceRefetch: true,
      },
    ),
  )

  return runCheck(
    promise,
    {
      id: brakeRatioCheckId,
      estimatedDuration: 3000,
    },
    updater,
  )
}
